//import ApiService from "../core/services/api.service";
import SearchApiService from "../core/services/searchapi.service";

export default {
  getMedicinesCount() {
    return SearchApiService.get(`Stats/medicines`);
  },
  getRequestsCount() {
    return SearchApiService.get(`Stats/requests`);
  },
};
